import photographyEntryPoints from '../../content/photography/photographyEntryPoints';
import { ContentNavItem, NavItem } from './NavItem';
import resumeEntryPoints from '../../content/resume/resumeEntryPoints';
import homeEntryPoints from '../../content/home/homeEntryPoints';
import contactEntryPoints from '../../content/about/contactEntryPoints';
import modelling3dEntryPoints from '../../content/modelling3d/modelling3dEntryPoints';
import unsplashEntryPoints from '../../content/unsplash/unsplashEntryPoints';
import oxalEntryPoints from '../../content/oxal/oxalEntryPoints';
import qrCodeProEntryPoints from '../../content/qr code pro/qrCodeProEntryPoints';
import appsEntryPoints from '../../content/apps/appsEntryPoints';

export const homePath = '';
export const changeImpactPath = 'change-impact';
export const ecosystemImpactPath = 'ecosystem-impact';
export const commsPlannerPath = 'comms-planner';
export const deprecationPeriodPath = 'deprecation-period';
export const forgeMigrationPath = 'forge-migration';
export const forgeAdoptionPath = 'forge-adoption';

class NavItems {

  allNavItems: NavItem[] = [];
  topLevelNavItems: NavItem[] = [];
  contentNavItems: ContentNavItem[] = [];
  homeNavItem: ContentNavItem;
  photographyNavItem: ContentNavItem;
  resumeNavItem: ContentNavItem;
  contactNavItem: ContentNavItem;

  appsNavItem: ContentNavItem;
  unsplashNavItem: ContentNavItem;
  oxalNavItem: ContentNavItem;
  qrCodeProNavItem: ContentNavItem;

  modelling3dNavItem: ContentNavItem;

  constructor() {
    this.homeNavItem = this.addHiddenNavItem(
      '',
      `Home`,
      homeEntryPoints.renderFullView,
      homeEntryPoints.renderIntroView);


      this.appsNavItem = this.addContentNavItem(
        'apps',
        `Apps`,
        appsEntryPoints.renderFullView,
        appsEntryPoints.renderIntroView);
      this.unsplashNavItem = this.addHiddenNavItem(
        'unsplash-for-confluence',
        `Unsplash for Confluence`,
        unsplashEntryPoints.renderFullView,
        unsplashEntryPoints.renderIntroView);
      this.oxalNavItem = this.addHiddenNavItem(
        'oxal',
        `Oxal`,
        oxalEntryPoints.renderFullView,
        oxalEntryPoints.renderIntroView);
      this.qrCodeProNavItem = this.addHiddenNavItem(
        'qrCodePro',
        `QRCodePro`,
        qrCodeProEntryPoints.renderFullView,
        qrCodeProEntryPoints.renderIntroView);


      this.modelling3dNavItem = this.addContentNavItem(
        'modelling3d',
        `3D`,
        modelling3dEntryPoints.renderFullView,
        modelling3dEntryPoints.renderIntroView);


      this.photographyNavItem = this.addContentNavItem(
      'photos',
      `Photos`,
      photographyEntryPoints.renderFullView,
      photographyEntryPoints.renderIntroView);
  

      this.resumeNavItem = this.addContentNavItem(
        'resume',
        `Resume`,
        resumeEntryPoints.renderFullView,
        resumeEntryPoints.renderIntroView);

      this.contactNavItem = this.addContentNavItem(
        'contact',
        `Contact`,
        contactEntryPoints.renderFullView,
        contactEntryPoints.renderIntroView);
    }

  getAllNavItems = (): NavItem[] => {
    return this.allNavItems;
  };

  getTopLevelNavItems = (): NavItem[] => {
    return this.topLevelNavItems;
  };

  getNavItemByKey = (key: string): undefined | NavItem => {
    for (const NavItem of this.allNavItems) {
      if (NavItem.key === key) {
        return NavItem;
      }
    }
    return undefined;
  };

  private addContentNavItem = (
    key: string,
    name: string,
    renderMainView: (navItem: NavItem, secondaryNavItems: string[], width: number, height: number) => any,
    renderIntroView: (navItem: NavItem, secondaryNavItems: string[]) => any
  ): ContentNavItem => {
    return this._addContentNavItem(key, name, false, renderMainView, renderIntroView);
  };

  private nilRenderer = () => {
    return null;
  }

  private addHiddenNavItem = (
    key: string,
    name: string,
    renderMainView: (navItem: NavItem, secondaryNavItems: string[], width: number, height: number) => any,
    renderIntroView: (navItem: NavItem, secondaryNavItems: string[]) => any
  ): ContentNavItem => {
    return this._addContentNavItem(key, name, true, renderMainView, renderIntroView);
  };

  private _addContentNavItem = (
    key: string,
    name: string,
    hidden: boolean,
    renderMainView: (navItem: NavItem, secondaryNavItems: string[], width: number, height: number) => any,
    renderIntroView: (navItem: NavItem, secondaryNavItems: string[]) => any
  ): ContentNavItem => {
    const navItem: ContentNavItem = {
      key: key,
      name: name,
      discoverable: !hidden,
      showInHomeView: !hidden,
      renderMainView: renderMainView,
      renderIntroView: renderIntroView
    };
    this.contentNavItems.push(navItem);
    this.allNavItems.push(navItem);
    if (!hidden) {
      this.topLevelNavItems.push(navItem);
    }
    return navItem;
  };
}

const navItems = new NavItems();
export default navItems;
